/**
 * @file index.tsx
 *
 * @fileoverview Renders the loading element for the toggle alert button.
 */
import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { isApplicant } from '~/jobiqo/lib/auth';
import { Button } from '~/vcl/atoms/01-forms/01-button';
import { EnvelopeIcon } from '~/vcl/icons/Envelope';

interface ToggleLoadingProps {}
export default function ToggleLoading({}: ToggleLoadingProps) {
  const intl = useIntl();
  const { user }: UserContextInterface = useContext(UserContext);
  const isUserApplicant = user && isApplicant(user);

  return !isUserApplicant ? (
    <Button
      raised={true}
      bordered={true}
      buttonStyle="primary"
      disabled={true}
      type="button"
    >
      <EnvelopeIcon
        title={intl.formatMessage({
          id: 'job_alert_subscribe',
          defaultMessage: 'Subscribe to job alerts!',
        })}
      />
      <span>
        <FormattedMessage
          id="job_alert_subscribe"
          defaultMessage="Subscribe to job alerts!"
        />
      </span>
    </Button>
  ) : null;
}
